import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { Textarea } from "./ui/textarea";
import { api } from "../lib/api";
import { wibTime } from "./ManagerRequests";

const site = () => window.location.origin;
const statusLink = () => `${site()}/ingin-menjadi-pemodal/cek-status`;
const SIGN = "\n\nSalam,\nPT SJI · Salimbado Farm";

const T = {
  MENUNGGU_REVIEW: [
    ["Pengajuan diterima", (a) => `Halo ${a.name}, terima kasih telah mengajukan diri sebagai Pemodal Kebun (kode ${a.code}). Pengajuan Anda sedang kami tinjau. Status dapat dicek kapan saja di ${statusLink()}`],
    ["Minta info tambahan", (a) => `Halo ${a.name}, terkait pengajuan Pemodal Kebun Anda (kode ${a.code}), boleh kami minta sedikit informasi tambahan mengenai rencana pendanaan Anda? Silakan balas pesan ini.`],
    ["Ajak bicara via telepon", (a) => `Halo ${a.name}, kami ingin berbincang singkat mengenai pengajuan Pemodal Kebun Anda (kode ${a.code}). Kapan waktu yang nyaman untuk kami telepon?`],
  ],
  PERLU_PERBAIKAN: [
    ["Ingatkan perbaikan", (a) => `Halo ${a.name}, pengajuan Pemodal Kebun Anda (kode ${a.code}) masih perlu diperbaiki. Tautan perbaikan sudah kami kirim ke email ${a.email}. Mohon cek juga folder Spam.`],
  ],
  DISETUJUI: [
    ["Pengajuan disetujui", (a) => `Halo ${a.name}, selamat! Pengajuan Pemodal Kebun Anda (kode ${a.code}) telah disetujui PT SJI. Tautan aktivasi akun dikirim ke email ${a.email}.`],
  ],
  MENUNGGU_AKTIVASI: [
    ["Ingatkan aktivasi", (a) => `Halo ${a.name}, akun Pemodal Kebun Anda (kode ${a.code}) belum diaktifkan. Silakan buka tautan aktivasi di email ${a.email} untuk membuat kata sandi. Bila tautan kedaluwarsa, balas pesan ini dan kami kirim ulang.`],
  ],
  AKUN_AKTIF: [
    ["Selamat bergabung", (a) => `Halo ${a.name}, akun Pemodal Kebun Anda sudah aktif. Silakan masuk di ${site()}/login dengan email ${a.email} untuk menelusuri Rencana Kebun yang tersedia. Simulasi bagi hasil adalah asumsi, bukan jaminan hasil.`],
    ["Tawarkan pendampingan", (a) => `Halo ${a.name}, bila Anda ingin ditemani menelusuri Rencana Kebun di aplikasi, kami siap membantu lewat telepon atau video call. Kapan waktu yang nyaman?`],
  ],
  DITOLAK: [
    ["Pemberitahuan sopan", (a) => `Halo ${a.name}, terima kasih atas minat Anda menjadi Pemodal Kebun (kode ${a.code}). Saat ini pengajuan belum dapat kami lanjutkan. Bila ada pertanyaan, silakan balas pesan ini.`],
  ],
};

const waNumber = (n) => { const d = (n || "").replace(/\D/g, ""); return d.startsWith("0") ? `62${d.slice(1)}` : d; };

const WaLog = ({ a }) => {
  const log = [...(a.waLog || [])].reverse();
  if (!log.length) return <p className="text-[11px] text-slate-500" data-testid={`ia-walog-empty-${a.id}`}>Belum ada balasan WhatsApp tercatat.</p>;
  return (
    <div className="space-y-1" data-testid={`ia-walog-${a.id}`}>
      <p className="text-xs font-semibold text-slate-700">Riwayat balasan ({log.length})</p>
      <ul className="max-h-48 overflow-y-auto divide-y rounded-md border bg-white">
        {log.map((l, i) => (
          <li key={`${l.at}-${i}`} className="px-3 py-2 text-xs" data-testid={`ia-walog-item-${a.id}-${i}`}>
            <p className="font-semibold text-slate-800">{l.template}<span className="font-normal text-slate-500"> · {wibTime(l.at)}{l.byName ? ` · ${l.byName}` : ""}</span></p>
            <p className="text-slate-600 line-clamp-2 break-words" title={l.text}>{l.text}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const QuickReplies = ({ a, reload }) => {
  const list = T[a.status] || [];
  const [idx, setIdx] = useState(0);
  const [text, setText] = useState(list.length ? list[0][1](a) + SIGN : "");
  if (!list.length) return null;
  const pick = (i) => { setIdx(i); setText(list[i][1](a) + SIGN); };
  const logSend = () => { api.post(`/admin/investor-applications/${a.id}/wa-log`, { template: list[idx][0], text }).then(() => reload?.()).catch(() => {}); };
  return (
    <details className="rounded-lg border border-green-200 bg-green-50/60 p-3 text-sm" data-testid={`ia-quick-${a.id}`}>
      <summary className="cursor-pointer font-semibold text-green-900" data-testid={`ia-quick-toggle-${a.id}`}>Balasan cepat WhatsApp</summary>
      <div className="mt-3 space-y-2">
        <div className="flex flex-wrap gap-2">
          {list.map(([label], i) => (
            <button key={label} type="button" onClick={() => pick(i)} data-testid={`ia-quick-opt-${a.id}-${i}`}
              className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${i === idx ? "bg-green-700 text-white border-green-700" : "bg-white text-green-900 border-green-300 hover:bg-green-100"}`}>{label}</button>
          ))}
        </div>
        <Textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} className="bg-white text-sm" data-testid={`ia-quick-text-${a.id}`} />
        <a href={`https://wa.me/${waNumber(a.whatsapp)}?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" onClick={logSend} data-testid={`ia-quick-send-${a.id}`}
          className="inline-flex items-center gap-1 h-9 px-3 rounded-full bg-green-600 text-white text-sm font-bold hover:bg-green-700 transition-colors"><MessageCircle className="h-4 w-4" />Buka WhatsApp ke {a.whatsapp}</a>
        <p className="text-[11px] text-slate-500">Pesan bisa diubah sebelum dikirim. Tautan aktivasi/perbaikan hanya dikirim lewat tombol keputusan agar tetap aman. Riwayat mencatat saat WhatsApp dibuka.</p>
        <WaLog a={a} />
      </div>
    </details>
  );
};
